import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { PARTY_COLORS } from "../lib/api";

/** Builds time-series rows from list of polls (each with results[]). */
function buildSeries(polls) {
  const sorted = [...polls].sort((a, b) => a.date.localeCompare(b.date));
  const rows = sorted.map((p) => {
    const row = { date: p.date, pollster: p.pollster };
    for (const r of p.results) row[r.candidate] = r.percentage;
    return row;
  });
  const candidates = Array.from(
    new Set(sorted.flatMap((p) => p.results.map((r) => ({ name: r.candidate, party: r.party }))).map((x) => JSON.stringify(x)))
  ).map((s) => JSON.parse(s));
  return { rows, candidates };
}

export default function PollChart({ polls, testId = "poll-chart" }) {
  const { rows, candidates } = buildSeries(polls || []);
  if (!rows.length) {
    return (
      <div className="border border-rule bg-white p-6 text-sm text-sub" data-testid={`${testId}-empty`}>
        Aún no hay encuestas para graficar.
      </div>
    );
  }
  return (
    <div className="border border-ink bg-white p-3 sm:p-4" data-testid={testId}>
      <ResponsiveContainer width="100%" height={340}>
        <LineChart data={rows} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
          <CartesianGrid stroke="#E5E1CF" vertical={false} />
          <XAxis dataKey="date" tick={{ fontFamily: "IBM Plex Mono", fontSize: 11, fill: "#4A4A4A" }} />
          <YAxis tick={{ fontFamily: "IBM Plex Mono", fontSize: 11, fill: "#4A4A4A" }} domain={[0, 100]} />
          <Tooltip
            contentStyle={{ background: "#0A0A0A", border: "none", color: "#F4F1EB", fontFamily: "Chivo" }}
            labelStyle={{ color: "#F4F1EB", fontFamily: "IBM Plex Mono" }}
            formatter={(v, n) => [`${v}%`, n]}
          />
          <Legend wrapperStyle={{ fontFamily: "Chivo", fontSize: 12 }} />
          {candidates.map((c) => (
            <Line
              key={c.name}
              type="monotone"
              dataKey={c.name}
              stroke={PARTY_COLORS[c.party] || "#0A0A0A"}
              strokeWidth={2.5}
              dot={{ r: 3 }}
              activeDot={{ r: 5 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
